import { Card, CardContent, Checkbox, Grid, TextField } from "@mui/material";
import CardHeaderColor from "components/MuiExtras/Card/CardHeaderColor";
import MuiContainer from "components/MuiExtras/MuiContainer";
import { UserPhoneType } from "models/ApiEnums";
import { UserPhoneModel } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    phones: UserPhoneModel[];
    editResidentialPhones: boolean;
    onChange: (v: UserPhoneModel[]) => void;
    message?: string | JSX.Element;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

interface ITextMaskProps {
    inputRef: any;
}

//function TextMaskCustom(props: ITextMaskProps) {
//    const { inputRef, ...other } = props;

//    return (
//        <MaskedInput
//            {...other}
//            ref={ref => {
//                inputRef(ref ? ref.inputElement : null);
//            }}
//            mask={
//                (rawValue: string) => {
//                    return (rawValue.length > 4 && parseInt(rawValue.substr(1, 3)) == 55)
//                        ? ['+', /\d/, /\d/, /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
//                        : ['+', /\d/, /\d/, /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
//                }
//            }
//            placeholderChar={'\u2000'}
//            showMask={false}
//        />
//    );
//}

/////////////////////////////////////////////////////////////////////////////////////

class UserEditPhones extends React.Component<Props> {

    ///
    private updatePhone = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number, type: UserPhoneType, opt: string) => {
        const { phones } = this.props;
        var phone = phones.find(p => p.index == index && p.type == type);

        if (phone == null) {
            if (opt == "phone")
                phones.push({ index: index, type: type, number: e.currentTarget.value, visibleToOthers: false });
            else
                phones.push({ index: index, type: type, number: "", visibleToOthers: (e.currentTarget as HTMLInputElement).checked });
        }
        else {
            if (opt == "phone")
                phone.number = e.currentTarget.value;
            else
                phone.visibleToOthers = (e.currentTarget as HTMLInputElement).checked;
        }

        const newPhones = phones.map((v) => {
            const phoneNoMask = v.number.replace(/\s|\+|\-|\(|\)/g, "");
            return {
                ...v,
                ...{ isValid: phoneNoMask.length == 0 || phoneNoMask.length > 6 }
            };
        });

        this.props.onChange(newPhones);
    };

    ///
    private renderPhone(index: number, type: UserPhoneType) {
        var phone = this.props.phones.find(p => p.index == index && p.type == type);
        return (
            <Grid container alignItems="flex-end" >
                <Grid item >
                    <Checkbox
                        checked={phone ? phone.visibleToOthers : false}
                        onChange={(e) => this.updatePhone(e, index, type, 'check')}
                        disabled={type == UserPhoneType.Residential && !this.props.editResidentialPhones}
                    />
                </Grid>
                <Grid item xs>
                    <TextField
                        fullWidth
                        margin="dense"
                        value={phone ? phone.number : ""}
                        error={phone ? phone.isValid === false : false}
                        onChange={(e) => this.updatePhone(e, index, type, 'phone')}
                        disabled={type == UserPhoneType.Residential && !this.props.editResidentialPhones}
                        label={this.props.t<string>(`Common.UserPhoneType.${UserPhoneType[type]}`) + " " + index}
                        inputProps={
                            {
                                maxLength: 20
                            }
                        }
                    />
                </Grid>
            </Grid>
        );
    }

    ///
    render() {

        return (
            <Card>
                <CardHeaderColor color="primary" title={this.props.t("Views.User.Components.UserEditPhones.HeaderTitle")} />

                <CardContent>
                    <MuiContainer margin="dense">
                        <Grid container alignItems={"baseline"}>
                            <Grid item xs={6} md={4}>{this.renderPhone(1, UserPhoneType.Comercial)}</Grid>
                            <Grid item xs={6} md={4}>{this.renderPhone(1, UserPhoneType.Mobile)}</Grid>
                            <Grid item xs={6} md={4}>{this.renderPhone(1, UserPhoneType.Residential)}</Grid>
                            <Grid item xs={6} md={4}>{this.renderPhone(2, UserPhoneType.Comercial)}</Grid>
                            <Grid item xs={6} md={4}>{this.renderPhone(2, UserPhoneType.Mobile)}</Grid>
                            <Grid item xs={6} md={4}>{this.renderPhone(2, UserPhoneType.Residential)}</Grid>
                        </Grid>
                    </MuiContainer>

                    {this.props.message && <span><br /> {this.props.message}</span>}

                </CardContent>

            </Card>
        );
    }
}

export default withTranslation()(UserEditPhones);